import {fetchPost} from "../../requests/NetworkRequestAuth0";
import {uri} from "./AppRequest";

export const createInvoicePaymentUrl = (
    venueId,
    invoiceId,
    successMethod,
    errorMethod,
    getAccessTokenSilently
) => {
    const params = {
        venueId: venueId,
        invoiceId: invoiceId
    };
    fetchPost(
        uri + "/venue/invoice/payment",
        successMethod,
        errorMethod,
        params,
        getAccessTokenSilently);
};